import axios from "axios";
import { Toast } from 'vant'
// var baseURL = process.env.VUE_APP_TSA_API;

function startLoading() {
    Toast.loading({
        message: '加载中...',
        overlay: true,
        forbidClick: true,
        duration: 0,
    })
}

function stopLoading() {
    Toast.clear()
}

axios.defaults.headers = {}

const service = axios.create({
    baseURL:'/content/api',
    timeout: 86400000,
    headers: {
        'content-type': 'application/x-www-form-urlencoded;charset=UTF-8'
            // 'content-type': "application/json;charset=UTF-8"
    }
});


service.interceptors.request.use(
    config => {
        // if (!config.stopLoading) {
        //     startLoading();
        // }
        return config;
    },
    error => {
        console.log(error); // for debug
        // stopLoading();
        return Promise.reject(error);
    }
);


service.interceptors.response.use(
    response => {
        // stopLoading();
        const { status, data } = response;
        if (response instanceof Blob) {
            return response;
        }
        if (status !== 200) {
            Message({
                message: data.message || "Error",
                type: "error",
                duration
            });
            return false;
        } else {
            return data
        }
    },
    error => {
        // stopLoading();
        let res = error.response;
        // /let message = "";
        console.log(error.response);
        // if (res && res.status === 500) {
        //     Message({
        //         message: res.data.message || '服务器异常',
        //         type: "error",
        //         duration
        //     });
        // } else {
        //     Message({
        //         message: res.data.message || '服务器异常',
        //         type: "error",
        //         duration
        //     });
        //     return res
        // }
        return Promise.reject(error.response.data);
    }
);

export default service;